var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2089 12C5.2089 11.2364 5.31799 10.4727 5.59071 9.76363L1.55435 6.65454C0.790714 8.23636 0.299805 10.0364 0.299805 11.9455C0.299805 13.8545 0.736168 15.6545 1.55435 17.2364L5.59071 14.1273C5.31799 13.5273 5.2089 12.7636 5.2089 12Z",
    fill: "#FABB08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55469 6.70909L5.59105 9.81818C6.51832 6.98182 9.19105 4.96364 12.3001 4.96364C13.9911 4.96364 15.5183 5.56364 16.7183 6.54545L20.2092 3C18.082 1.14545 15.3547 0 12.3001 0C7.55469 0 3.46378 2.72727 1.55469 6.70909Z",
    fill: "#E94135"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5844 14.1193C6.51167 16.9556 9.13602 19.0909 12.2997 19.0909C13.8397 19.0909 15.2044 18.7287 16.2857 18.0474L20.1165 21.0157C18.0195 22.9631 15.2244 24 12.2997 24C7.5542 24 3.46183 21.1626 1.55273 17.2354L5.5844 14.1193Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 9.81818V14.4545H18.7362C18.4089 16.0364 17.5362 17.2364 16.2816 18.0545L20.0998 21C22.2816 18.9273 23.7543 15.9273 23.7543 12C23.7543 11.2909 23.6453 10.5273 23.4816 9.81818H12.2998Z",
    fill: "#4285F4"
  })));
};
export default SvgGoogle;